// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"Usps_visuallyHidden__OdvCO","stars":"Usps_stars__vW0ep","usps":"Usps_usps__lB5Ty","uspItem":"Usps_uspItem__ubPaQ","spinner":"Usps_spinner__tZq6j"};